
<div *ngIf="project$ | async as project; else loading">

  <div *ngIf="viewState === 'form'">
    <h2 class="widget-header" i18n="@@edit-project-retention-form-header">Edit project retention</h2>
    <p>
      <span i18n="@@project">Project</span>: <strong>{{project.Name}}</strong>
      <br />
      <span i18n="@@current-retention">Current retention</span>:
      <span class="font-weight-bold" *ngIf="project.Retention === -1" i18n="@@retention-forever">Forever</span>
      <span class="font-weight-bold" *ngIf="project.Retention !== -1">{{project.Retention}} <span i18n="@@retention-years">years</span></span>
    </p>

    <hr />

    <ul class="" i18n="Create Site - Retention Form Label@@group-retention-help">
      <li>7 years - In accordance with accounting laws, normally not used in PDP</li>
      <li>10 years - Normal RISE working process; recommended unless otherwise stated.</li>
      <li>30 years - Used if there is an agreement with customer, internal requirements or when required by laws and regulations.</li>
      <li>Forever - Used if there is an agreement with customer, internal requirements or when required by laws and regulations.</li>
      <li>If unsure of what to choose, contact "Hållbarhet & Kvalitet": <a href="mailto:support.kvalitet@ri.se">support.kvalitet@ri.se</a></li>
    </ul>

    <form [formGroup]="formGroupRetention">
      <div class="retention-options">
        <mat-radio-group formControlName="Retention" [(ngModel)]="selectedRetention">
          <mat-radio-button class="" [value]="7">7 <span i18n="Create Site - Retention Option Years@@group-retention-option-years">years</span></mat-radio-button>
          <mat-radio-button class="" [value]="10">10 <span i18n="Create Site - Retention Option Years@@group-retention-option-years">years</span></mat-radio-button>
          <mat-radio-button class="" [value]="30">30 <span i18n="Create Site - Retention Option Years@@group-retention-option-years">years</span></mat-radio-button>
          <mat-radio-button class="" [value]="-1"><span i18n="Create Site - Retention Option Forever@@group-retention-option-forever">Forever</span></mat-radio-button>
        </mat-radio-group>
      </div>
    </form>

    <button mat-button mat-flat-button class="cancel-button mr-2" [routerLink]="'/'" type="button" i18n="@@cancel">Cancel</button>
    <button mat-button mat-flat-button color="primary" class="mt-4" [disabled]="selectedRetention === project.Retention" (click)="updateProject()" type="button" i18n="@@save">Save</button>
  </div>

  <div *ngIf="viewState === 'working'">
    <div class="text-center mt-6">
      <p><mat-spinner [diameter]="25" style="margin: 0 auto;"></mat-spinner></p>
      <p i18n="@@saving">Saving...</p>
    </div>
  </div>

  <div *ngIf="viewState === 'ready'">
    <div class="text-center mt-6">
      <p>
        <i aria-hidden="true" class="ready-check ms-Icon ms-Icon--SkypeCircleCheck align-middle"></i>
        &nbsp;
        <strong>{{project.Name}}</strong>&nbsp;<span i18n="@@has-been-updated">has been updated!</span>
      </p>
      <p class="mt-5">
        <a i18n="@@back-to-project-list" [routerLink]="'/'">Return to the project list.</a>
      </p>
    </div>
  </div>

  <div *ngIf="viewState === 'error'">
    <div class="text-center mt-6">
      <p>
        <i aria-hidden="true" class="error-icon ms-Icon ms-Icon--StatusErrorFull align-middle"></i>
        &nbsp;
        <span i18n="@@something-went-wrong">Something went wrong. Please try again or contact support!</span>
      </p>
      <p>
        <small>{{errorMessage}}</small>
      </p>
    </div>
  </div>

</div>


<ng-template #loading>
  <div class="text-center mt-6">
    <p><mat-spinner [diameter]="25" style="margin: 0 auto;"></mat-spinner></p>
  </div>
</ng-template>

